import { render, staticRenderFns } from "./Pos_invoices_tax_detail.vue?vue&type=template&id=7554811c&scoped=true&"
import script from "./Pos_invoices_tax_detail.vue?vue&type=script&lang=js&"
export * from "./Pos_invoices_tax_detail.vue?vue&type=script&lang=js&"
import style0 from "./Pos_invoices_tax_detail.vue?vue&type=style&index=0&id=7554811c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554811c",
  null
  
)

export default component.exports